import { nanoid } from 'nanoid';

import { type BuildQuizListItem } from './BuildQuizListSchema';

export const getBlankQuizItem = (): BuildQuizListItem => {
  return {
    id: nanoid(8),
    question: '',
    questionRichText: '',
    questionImageUrl: '',
    hint: undefined,
    type: 'multiple',
    multipleData: getBlankMultipleData(),
    subjectiveData: getBlankSubjectiveData(),
    oxData: getBlankOXData(),
    essayData: {},
  };
};

const getBlankMultipleData = () => {
  const firstChoiceKey = nanoid(8);
  return {
    choiceList: [
      {
        key: firstChoiceKey,
        text: '',
        richText: '',
        imageUrl: undefined,
        isAnswer: true,
      },
      {
        key: nanoid(8),
        text: '',
        richText: '',
        imageUrl: undefined,
        isAnswer: false,
      },
      {
        key: nanoid(8),
        text: '',
        richText: '',
        imageUrl: undefined,
        isAnswer: false,
      },
      {
        key: nanoid(8),
        text: '',
        richText: '',
        imageUrl: undefined,
        isAnswer: false,
      },
    ],
  };
};

const getBlankSubjectiveData = () => {
  const firstAnswerKey = nanoid(8);
  return {
    answerList: [{ key: firstAnswerKey, text: '' }],
  };
};

const getBlankOXData = () => {
  return {
    answer: 'o' as const,
  };
};
